import React from "react";
import {withTranslate} from "react-redux-multilingual";


const ServiceCard = ({doctor, service, translate, language}) => {
    return (
        <div id="accordion" className="services-accordion">
            <div className="card shadow-4d">
                <div className="card-header">
                    <a className="card-link loon"
                       data-toggle="collapse" href="#service1"
                       aria-expanded="true"
                       aria-controls="menuone">
                        <p className={language === "ar" ? "pull-right loon" : "pull-left loon"}>{service.name}</p>
                        <div className={language === "ar" ? "pull-left" : "pull-right"}>
                            <small
                                className={doctor.is_premium === 0 ? "bolder" : "premium-price grey"}>{service.price} &nbsp;&nbsp; {translate("currency")}</small>
                            <small
                                hidden={doctor.is_premium === 0}>{service.premium_price} &nbsp;&nbsp; {translate("currency")}</small>
                        </div>
                    </a>
                </div>
                <div id="service1" className="collapse"></div>
            </div>
        </div>
    )
};
export default withTranslate(ServiceCard);